module.exports = __webpack_public_path__ + "img/vault.dabdf9b8.svg";